<!-- <h6>{{ tenant.Name }} Identifiers</h6> -->
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button class="btn btn-primary" kendoGridAddCommand>
      <fa-icon icon="plus"></fa-icon>
      <!-- New Tenant Identifier -->
    </button>
  </ng-template>

  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column
    field="TenantId"
    title="Tenant ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column field="Type" title="Type">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-isNew="isNew">
      <input #input class="k-textbox" [formControl]="formGroup.get('Type')">
      <kendo-popup
        [anchor]="input"
        *ngIf="formGroup.get('Type').invalid && !(isNew && formGroup.get('Type').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
       <div class="tooltip-stacked">
        <div *ngIf="formGroup.get('Type').hasError('required')">
          <span class="k-icon k-i-warning"></span>
          Type is required
         </div>
         <div *ngIf="formGroup.get('Type').hasError('minlength')">
          <span class="k-icon k-i-warning"></span>
          Type must be at least 3 characters
         </div>
         <div *ngIf="formGroup.get('Type').hasError('maxlength')">
          <span class="k-icon k-i-warning"></span>
          Type must not exceed 50 characters
         </div>
         <div *ngIf="formGroup.get('Type').hasError('pattern')">
          <span class="k-icon k-i-warning"></span>
          Type must only contain letters, underscores, dashes
         </div> 
       </div>
      </kendo-popup>
    </ng-template>       
  </kendo-grid-column>

  <kendo-grid-column field="Value" title="Value">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-isNew="isNew">
      <input #input class="k-textbox" [formControl]="formGroup.get('Value')">
      <kendo-popup
        [anchor]="input"
        *ngIf="formGroup.get('Value').invalid && !(isNew && formGroup.get('Value').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
        <div class="tooltip-stacked">
          <div *ngIf="formGroup.get('Value').hasError('required')">
            <span class="k-icon k-i-warning"></span>
            Value is required
           </div>
           <div *ngIf="formGroup.get('Value').hasError('minlength')">
            <span class="k-icon k-i-warning"></span>
            Value must be at least 3 characters
           </div>         
           <div *ngIf="formGroup.get('Value').hasError('maxlength')">
            <span class="k-icon k-i-warning"></span>
            Value must not exceed 500 characters
           </div>
           <div *ngIf="formGroup.get('Value').hasError('pattern')">
            <span class="k-icon k-i-warning"></span>
            Value must only contain letters, numbers, underscores, dashes, periods, colons, slashes
           </div> 
           <div *ngIf="formGroup.get('Value').hasError('unique')">
            <span class="k-icon k-i-warning"></span>
            Value is already taken by another tenant identifier
           </div> 
        </div>         
      </kendo-popup>
    </ng-template>     
  </kendo-grid-column>

  <kendo-grid-command-column title="" width="200">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button class="btn-sm btn-primary" kendoGridEditCommand>
        <fa-icon icon="pen"></fa-icon>
      </button>
      <button class="btn-sm btn-danger" kendoGridRemoveCommand>
        <fa-icon icon="trash"></fa-icon>
      </button>
      <button
        class="btn-sm btn-primary"
        kendoGridSaveCommand
        [disabled]="formGroup?.invalid"
      >
        <fa-icon icon="check"></fa-icon>
      </button>
      <button class="btn-sm btn-secondary" kendoGridCancelCommand>
        <fa-icon icon="times"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
